module.exports = __webpack_public_path__ + "img/ilu-download.b25a3f7a.png";